export const todosProdutos = [
  //------------------------------------- PRODUCTOS EMULSIONES -------------------------------------
  {
    filtro: ['Emulsiones', 'Decorativas'],
    nome: 'Acronal® LR 9014',
    desc: 'Dispersión acuosa hidrófoba de tamaño fino, de un copolímero acrílico puro, multifásico, con una morfología hecha a medida y un especial promotor de adhesión húmedo. Recomendado principalmente para pinturas de brillo, revestimientos decorativos exteriores de madera. Emulsión acrílica pura, hidrófoba de partícula fina con excelente adhesión en húmedo. Recomendada para Esmaltes, Lasures, Barnices acuosos, pinturas para piletas, protectores de ladrillos, etc.',
  },
  {
    filtro: ['Emulsiones', 'Decorativas'],
    nome: 'Acronal® 1568 sa',
    desc: 'Dispersión de un copolímero acrílico y estireno, libre de APEO. Aglutinante en la fabricación de pinturas y recubrimientos elastoméricos de alto módulo elástico y bajo dirty pick up. Recomendado principalmente para recubrimientos elásticos, tales como sistemas elásticos para impermeabilización de techos y fachadas. Emulsión estireno-acrílica con muy buena recuperación elástica y resistencia al ensuciamiento. Recomendada para recubrimientos elásticos, impermeabilizantes de techos, frentes y muros.',
  },
  {
    filtro: ['Emulsiones', 'Decorativas'],
    nome: 'Acronal® 295 sa',
    desc: 'Dispersión acuosa de un copolímero acrílico y estireno, con muy elevada capacidad de ligar pigmentos, exenta de plastificantes. Recomendado principalmente para pinturas de interior y exterior desde altamente brillantes hasta mates. Emulsión estireno-acrílica de muy buena resistencia a la abrasión, estabilidad y amplitud de formulación. Recomendada para pinturas de interior y exterior, masillas, adhesivos en pasta, revestimientos texturados, etc.',
  },
  {
    filtro: ['Emulsiones', 'Decorativas'],
    nome: 'Acronal® BV 275',
    desc: 'Emulsión acrílica de altos sólidos y excelente estabilidad y flexibilidad en frío. Alta capacidad de recuperación elástica. Recomendada principalmente para:  Adhesivos para pisos y masillas y selladores acrílicos.',
  },
  {
    filtro: ['Emulsiones', 'Decorativas'],
    nome: 'Acronal® RS 723 sa',
    desc: 'Dispersión acuosa de un copolímero acrílico estirenado libre de  formaldehido, empleado como ligante en la fabricación de masillas de recubrimiento y pinturas látex confiriendo alto poder ligante. Recomendado principalmente para pinturas de interior y exterior, masillas y texturas. Emulsión estireno-acrílica de excelente resistencia a la abrasión, estabilidad y amplitud de formulación. Recomendada para pinturas de interior y exterior, masillas, adhesivos en pasta, revestimientos texturados, etc.',
  },
  {
    filtro: ['Emulsiones', 'Decorativas'],
    nome: 'Acronal® S 400',
    desc: 'Dispersión acuosa aniónica de un copolímero basado en acrilatos y estireno, que se emplea principalmente para la modificación de los ligantes hidráulicos. Las áreas de aplicación incluyen: Puente de Adherencia, Membrana cementicia, Impermeabilización cementicia. Emulsión estireno-acrílica de altos sólidos para modificación de mezclas cementicias y ligantes hidráulicos. Recomendada principalmente para puentes de adherencia, membranas cementicias, impermeabilización cementicia y impermeabilizantes elásticos, entre otras.',
  },
  {
    filtro: ['Emulsiones', 'Decorativas'],
    nome: 'Acronal® S 702',
    desc: 'Dispersión acuosa, exenta de plastificantes, a base de un copolímero de éster de ácido acrílico y estireno. Especialmente diseñado para modificación de morteros, Pisos industriales y Micropisos. Emulsión estireno-acrílica para reducción de agua en morteros mejorando notablemente las propiedades mecánicas. Recomendada principalmente para micropisos, pisos industriales y morteros de reparación.',
  },
  {
    filtro: ['Emulsiones', 'Decorativas'],
    nome: 'Stryrofan®  D 623',
    desc: 'Dispersión aniónica acuosa basada en estireno y butadieno. Preferentemente usado cuando las propiedades mecánicas de los productos  requieren ser muy altas (como morteros para reparaciones y pisos autonivelantes). Emulsión estireno-butadieno para modificación de morteros. Recomendada principalmente para morteros de reparación y pisos autonivelantes.',
  },
  {
    filtro: ['Emulsiones', 'Decorativas'],
    nome: 'AqaCell Hide® 6299',
    desc: 'Opacificante de última generación, diseñado para proporcionar opacidad y blancura a las pinturas al extender y/o mejorar la eficiencia del TiO2 sin sacrificar las propiedades de revestimiento interior o exterior. Amplio rango de formulación. Efecto de espaciamiento de un pigmento que conduce a una mayor eficiencia de TiO2.',
  },
  {
    filtro: ['Emulsiones', 'Decorativas'],
    nome: 'Acronal® PU 1509',
    desc: 'Copolímero acrílico-estireno-poliuretano acuoso, diseñado para formulaciones de recubrimientos elastoméricos. Recomendado para membranas impermeabilizantes, revestimientos para cubiertas planas y recubrimientos elastoméricos. Emulsión hibrida Acrílica poliuretánica diseñada para formulaciones de recubrimientos elastoméricos. Recomendada para recubrimientos elastoméricos, impermeabilizantes de techos, frentes y muros.',
  },
  {
    filtro: ['Emulsiones', 'Decorativas'],
    nome: 'Acronal® RS 724',
    desc: 'Dispersión acuosa de un copolímero acrílico-estirenado, APEO-free. Empleado en la producción de acabados arquitectónicos, aumentando la resistencia al frote de pinturas interiores y exteriores.',
  },
  {
    filtro: ['Emulsiones', 'Decorativas'],
    nome: 'Acronal® DS 6254',
    desc: 'Dispersión polimérica acuosa de acrílico puro con excelente resistencia al blushing y a la hidrofobicidad. Recomendado principalmente para acabados de piedra de mármol, revestimientos texturados y tintes para madera.',
  },
  {
    filtro: ['Emulsiones', 'Decorativas'],
    nome: 'Acronal® 1840',
    desc: 'Dispersión estireno-acrílica base agua para sistemas cementicios, que aporta alta flexibilidad y excelente resistencia al agua en aplicaciones de construcción.',
  },
  {
    filtro: ['Emulsiones', 'Decorativas'],
    nome: 'Acronal® RS 401',
    desc: 'Dispersión estireno-acrílica base agua, autoreticulante, diseñada para recubrimientos elásticos, que ofrece alta flexibilidad, buena resistencia mecánica y baja absorción de agua.',
  },

  //------------------------------------- PRODUCTOS ADITIVOS -------------------------------------

  {
    filtro: ['Aditivos', 'Industriales'],
    nome: 'Irganox® 1076',
    desc: 'Antioxidante fenólico primario altamente efectivo para sustratos orgánicos como recubrimientos, plásticos, elastómeros, adhesivos, ceras. Protege estos sustratos contra la termooxidación.',
  },
  {
    filtro: ['Aditivos', 'Industriales'],
    nome: 'Tinuvin® 1130',
    desc: 'Benzotriazol líquido hidrofílico grado UVA. Filtro UVA con una amplia cobertura espectral y buena estabilidad térmica. Su resistencia a altas temperaturas y fotopermanencia lo hacen adecuado para pinturas industriales y automotrices.',
  },
  {
    filtro: ['Aditivos', 'Industriales'],
    nome: 'Tinuvin® 292 ',
    desc: 'HALS líquido multiusos para recubrimientos. Proporciona una alta estabilidad térmica, durabilidad y minimiza los defectos de la pintura, como el agrietamiento y la pérdida de brillo.',
  },
  {
    filtro: ['Aditivos', 'Industriales'],
    nome: 'Efka® PB 2001',
    desc: 'Antiespumante libre de silicona especialmente desarrollado para recubrimientos altamente viscosos en sistemas solventes alquídicos, epoxi, poliuretano y poliéster saturado.',
  },
  {
    filtro: ['Aditivos', 'Decorativas'],
    nome: 'Foamaster® MO 2157',
    desc: 'Antiespumante emulsionado para sistemas al agua, especialmente desarrollado para pinturas y recubrimientos de alto PVC. Ofrece rápida eliminación de espuma superficial y buena acción desaireante, con fácil incorporación.',
  },
  {
    filtro: ['Aditivos', 'Decorativas'],
    nome: 'Foamaster® MO 2159',
    desc: 'Antiespumante de aceite mineral emulsionado desarrollado para sistemas de pintura a base de agua, principalmente pinturas decorativas con alto contenido de PVC. Excelente acción desaireante y humectante del sustrato. Contribuye a una buena nivelación. Tiene fácil incorporación y tiene un gran costo/rendimiento',
  },
  {
    filtro: ['Aditivos', 'Decorativas'],
    nome: 'FoamStar® ST 2410 SJ',
    desc: 'Antiespumante a base de aceite mineral que actúa a nivel molecular y contiene propiedades humectantes que no se encuentran en los antiespumantes no convencionales. Alta eficiencia en la rotura de espuma en pinturas mate, satinadas y semibrillantes. Mejora la nivelación y la formación de película. materia activa: 100%',
  },
  {
    filtro: ['Aditivos', 'Decorativas'],
    nome: 'Dispex® AA 4146',
    desc: 'Dispersante y auxiliar de molienda para cargas y pigmentos inorgánicos, con muy buena estabilidad en el tiempo. Altamente eficiente, con efectos sinérgicos en combinación con polifosfatos. 45% de sólidos.',
  },
  {
    filtro: ['Aditivos', 'Decorativas'],
    nome: 'Dispex® CX 4320',
    desc: 'Dispersante acrílico de alta performance para sistemas acuosos que necesitan mejorar su hidrofobicidad y brillo. Excelente estabilización de pigmentos y cargas inorgánicos. Aumenta la resistencia al lavado en húmedo y reduce la tendencia al blocking. Aumenta el brillo de la película. Especialmente recomendado para esmaltes al agua.',
  },
  {
    filtro: ['Aditivos', 'Industriales'],
    nome: 'Efka® FA 4644',
    desc: 'Agente dispersante de bajo peso molecular para sistemas base solvente y solvente-free que reduce la tensión interfacial entre los pigmentos y el vehículo. Reduce el tiempo de dispersión, promueve la estabilización de la dispersión del pigmento, reduce la sedimentación pigmentaria y aumenta el brillo.',
  },
  {
    filtro: ['Aditivos', 'Industriales'],
    nome: 'Efka® FA 4663 SJ',
    desc: 'Agente dispersante, antisedimentante y antiflotación de aplicación universal para sistemas no acuosos.  Excelente gelificante para bentonitas modificados orgánicamente.',
  },
  {
    filtro: ['Aditivos', 'Industriales'],
    nome: 'Efka® FA 4665 ',
    desc: 'Agente dispersante de bajo peso molecular que ayuda a prevenir la tensión interfacial entre pigmentos/diluyentes y aglutinantes. Especialmente adecuado para aglutinantes de polaridad media a alta. Reduce la formación de celdas de Bénard y la tendencia a la cáscara de naranja. Mejora brillo y slip.',
  },
  {
    filtro: ['Aditivos', 'Industriales'],
    nome: 'Efka® PU 4063',
    desc: 'Agente humectante y dispersante polimérico para la defloculación de pigmentos orgánicos e inorgánicos en pastas pigmentarias a base de solventes de alta calidad. Reduce el tiempo de molienda, aumenta el brillo, evita la sedimentación y floculación de los pigmentos, aumenta la intensidad del color.',
  },
  {
    filtro: ['Aditivos', 'Decorativas'],
    nome: 'Basophob® PE',
    desc: 'Emulsión  de cera polietileno y parafinas para utilizar como aditivo en la formulación de pinturas para mejorar la resistencia al agua y el blocking. Aditivo de la preparación de pinturas que mejora la hidrofobicidad de la misma y reduce el blocking.',
  },
  {
    filtro: ['Aditivos', 'Industriales'],
    nome: 'Efka® IO 6782',
    desc: 'Aditivo para aumentar la conductividad. Aumenta la conductividad de los sistemas de recubrimiento. Esto es especialmente importante para las pinturas pulverizadas electrostáticamente.',
  },
  {
    filtro: ['Aditivos', 'Industriales'],
    nome: 'Efka® FL 3740 EH',
    desc: 'Agente de flujo y nivelación con propiedades de liberación de aire. Evita el atrapamiento de aire y optimiza la humectación del sustrato en sistemas base solvente.',
  },
  {
    filtro: ['Aditivos', 'Decorativas'],
    nome: 'Hydropalat® WE 3105',
    desc: 'Humectante basado en un alcohol etoxilado especialmente recomendado para la fabricación de pastas pigmentarias. Hydropalat® WE 3105 es un agente humectante y dispersante para la fabricación de pastas pigmentarias libre de resinas y solventes. Hydropalat® WE 3105 presenta excelente compatibilidad con sistemas acuosos y no acuosos.',
  },
  {
    filtro: ['Aditivos', 'Decorativas'],
    nome: 'Attagel® 40 printed',
    desc: 'Gelificante en polvo inerte de attapulgita que proporciona espesamiento y suspensión tixotrópicos. Recomendado para pinturas y recubrimientos donde se requiere resistencia al pandeo, control de salpicaduras y control de sinéresis. ',
  },
  {
    filtro: ['Aditivos', 'Decorativas'],
    nome: 'Rheovis® HS 1175',
    desc: 'Espesante acrílico asociativo (HASE) especialmente recomendado para látex con alto PVC. Rheovis® HS 1175 posee alta capacidad de promover asociaciones hidrofóbicas con ligantes acrílicos y otros componentes  de la formulación. Optimiza performance a mayores tasas de cizallamiento.',
  },
  {
    filtro: ['Aditivos', 'Decorativas'],
    nome: 'Rheovis® HS 1181',
    desc: 'Espesante acrílico asociativo (HASE) especialmente recomendado para látex, texturados y masillas. Rheovis® HS 1181 posee alto poder asociatividad y óptimo poder de espesado. Optimiza performance a bajas  tasas de cizallamiento.',
  },
  {
    filtro: ['Aditivos', 'Decorativas'],
    nome: 'Rheovis® HS 1185',
    desc: 'Espesante acrílico asociativo tipo HASE, libre de APEO, para sistemas al agua, que ofrece alto poder de espesamiento. Especialmente indicado para masillas (corrida y acrílica) y texturas, donde se destaca por su fácil incorporación y buena humectación.',
  },
  {
    filtro: ['Aditivos', 'Decorativas'],
    nome: 'Rheovis® PU 1235 EC',
    desc: 'Espesante Poliuretánico (HEUR) altamente eficaz para una amplia gama de recubrimientos a base de agua. Modificador reológico de cizallamiento medio recomendado para pinturas interior y exterior que requieran buenas propiedades de aplicación con brocha y rodillo.',
  },

  //------------------------------------- PRODUCTOS ADITIVOS -------------------------------------
  {
    filtro: ['Resinas', 'Industriales'],
    nome: 'Versamid® 115',
    desc: 'Agente de curado EPOXI. Resina de poliamida líquida de alta viscosidad para uso con resinas epoxi líquidas y sólidas. Se recomienda en aplicaciones como: Recubrimientos de mantenimiento, imprimaciones y formulaciones de esmaltes.',
  },
  {
    filtro: ['Resinas', 'Industriales'],
    nome: 'Versamid® 115/70',
    desc: 'Agente de curado EPOXI. Es una solución al 70% en xileno del Versamid® 115, resina de poliamida reactiva de alta viscosidad diseñada para su uso con resinas epoxi sólidas o líquidas. Resina que cura a temperatura ambiental para aplicaciones en recubrimientos de mantenimiento, imprimaciones y formulaciones de esmaltes. También en aplicaciones adhesivas.',
  },
  {
    filtro: ['Resinas', 'Industriales'],
    nome: 'Versamid® 125',
    desc: 'Agente de curado EPOXI. Es una resina de poliamida reactiva de viscosidad media que promueve la resistencia química en aplicaciones en recubrimientos termoestables con curado a temperatura ambiente. Se destaca su alta resistencia química y a la abrasión, así como por su capacidad para adherirse a una amplia variedad de sustratos.',
  },
  {
    filtro: ['Resinas', 'Industriales'],
    nome: 'Versamine® C 31',
    desc: 'Agente de curado EPOXI. Amina cicloalifática modificada para su uso como agente de curado en un sistema epoxi. Amina cicloalifática modificada de viscosidad extremadamente baja, excelente fluidez y planitud, y resistencia superior al rubor. Ideal para sistemas con alto contenido de sólidos.',
  },
  {
    filtro: ['Resinas', 'Industriales'],
    nome: 'Basonat® HB 175 MP/X',
    desc: 'Poliisocianato de HDI (Alifático) para uso general en sistemas de poliuretano de dos componentes. Uso en formulaciones de pintura de poliuretano de dos componentes con resistencia a la luz y a la intemperie.',
  },
  {
    filtro: ['Resinas', 'Industriales'],
    nome: 'Basonat® HI 190 B/S NG',
    desc: 'Poliisocianato trímero de HDI (Alifático)  para uso general en sistemas de poliuretano bicomponente. Recomendado para aplicación en spray. Excelente combinación de baja espuma, nivelación y humectación del sustrato. No interfiere con la adhesión entre capas.',
  },
  {
    filtro: ['Resinas', 'Industriales'],
    nome: 'Lupranat® M 20 S',
    desc: 'Poliisocianato de MDI (Aromático)  que se utiliza principalmente en la producción de pinturas de poliuretano, adhesivos, selladores,',
  },
  {
    filtro: ['Resinas', 'Industriales'],
    nome: 'Joncryl® U 4190',
    desc: 'Joncryl® U 4190 es una emulsión poliuretanica que ofrece una combinación de dureza de película, flexibilidad y tenacidad, junto con una excelente resistencia a la abrasión. Otorga una excelente resistencia al agua a los revestimientos para madera, metal, hormigón y plásticos. Resina poliuretanica alifática a base de agua, libre de NMP, económico y ecológico.',
  },
  {
    filtro: ['Resinas', 'Industriales'],
    nome: 'Joncryl® 507',
    desc: 'Polímero acrílico  hidroxilado (poliol) para sistemas puliuretánicos 2K con alto contenido de sólidos. Los recubrimientos formulados con Joncryl® 507 se caracterizan por una baja viscosidad con alto contenido de sólidos y un excelente flujo y nivelación con durabilidad acrílica. Se recomienda para aplicaciones de recubrimiento de poliuretano en el mercado de recubrimientos industriales. Recomendado para pintura automotriz, pintura marina y mantenimiento de pisos de madera.',
  },
  {
    filtro: ['Resinas', 'Industriales'],
    nome: 'Joncryl® Wax 26',
    desc: 'Emulsión de cera de polietileno con un 26% de sólidos y tamaño de partícula pequeño que mejora la resistencia al frote de las tintas y recubrimientos a base de agua sin pérdida significativa de brillo. El tamaño de partícula fina de este producto lo hace ideal para aplicaciones de alto brillo, sobreimpresión, barniz y huecograbado.',
  },
  {
    filtro: ['Resinas', 'Industriales'],
    nome: 'Laropal® A 81',
    desc: 'Resina de aldehído para la molienda y dispersión universal de pigmentos. Resina de aldehído con excelente compatibilidad y solubilidad. Promueve una buena humectación de los pigmentos, baja viscosidad y buena estabilidad a la luz. Ideal para fabricación de concentrados de pigmentos compatibles con múltiples sistemas y resinas.',
  },
  {
    filtro: ['Resinas', 'Industriales'],
    nome: 'Sovermol® 1058',
    desc: 'Poliol super-hidrófobo libre de VOC con alto contenido de materia prima renovable (80-100%). Diluyente no reactivo, plastificante para polioles (tipo Sovermol® 1058).',
  },
  {
    filtro: ['Resinas', 'Industriales'],
    nome: 'Sovermol® 750',
    desc: 'Poliol ramificado super-hidrófobo de baja viscosidad con alto contenido de materia prima renovable (65-80%). Resistente a los rayos UV y a la intemperie. Buena estabilidad a la saponificación y excelente resistencia química. Poliol de alta Tg. 100% materia activa. Aplicaciones: Pinturas industriales, Pisos drenantes y autonivelantes en mezclas con cemento.',
  },
].map((produto, index) => ({
  id: index + 1,
  ...produto,
}))
